import React, {Fragment, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import * as api from "../../apis/designerCommission";
import useAntTable from "../../utils/useAntTable";
import {Button, Divider, Popconfirm, Space} from "antd";
import WithAuth from "../../utils/withAuth";
import useFormModal from "../../utils/useFormModal";
import {useRequest} from "ahooks";
import ModifyModal from "./modifyModal";
import UploadModal from "../../components/UploadModal";

const AddButton = WithAuth('add', Button)
const EditFragment = WithAuth('edit', Fragment)
const DeletePopconfirm = WithAuth('delete', Popconfirm)


function DesignerCommission() {

    const {tableProps, refresh} = useAntTable(api.getDesignerCommissions, {})

    const [importModalVisible, setImportModalVisible] = useState(false)

    const {run: onImport, loading: onImporting} = useRequest(api.importDesignerCommissions, {
        manual: true,
        onSuccess: (response) => {
            window.location.reload()
        }
    })

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.modifyDesignerCommission,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteDesignerCommission, {
        manual: true,
        onSuccess: () => refresh()
    })

    const columns: StandardColumnsType = [
        {
            title: 'Model No.',
            dataIndex: 'model',
        },
        {
            title: 'Commission rate(%)',
            dataIndex: 'commissionRate',
        },
        {
            title: 'Designer',
            dataIndex: 'designer',
        },
        {
            title: 'BU',
            dataIndex: 'bu',
        },
        {
            title: 'Operations',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>Edit</a>
                        <Divider type={'vertical'}/>
                    </EditFragment>
                    <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete(record.id)}>
                        <a>Delete</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>Add</AddButton>
                    <AddButton type={'primary'} onClick={() => setImportModalVisible(true)}>Import</AddButton>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
            <UploadModal title={'Import Designer Commission'}
                         template={'/template/designerCommission.xlsx'}
                         confirmLoading={onImporting}
                         onUpload={onImport}
                         visible={importModalVisible}
                         onCancel={() => setImportModalVisible(false)}/>
        </PageHeaderLayout>
    )
}

export default DesignerCommission
